export default "assets/images/logo-72acace2.svg";